import React from 'react'
import { MenuItem } from '@mui/material'

import AccentLabel, { type AccentLabelProps } from '../labels/AccentLabel'

export interface AccentSelectItemProps extends AccentLabelProps {
  classes?: any
  onClick?: (event: React.MouseEvent<any>) => void
}

export const StylableAccentSelectItem = ({
  classes,
  onClick,
  ...rest
}: AccentSelectItemProps) => (
  <MenuItem onClick={onClick}>
    <AccentLabel {...rest} classes={classes} />
  </MenuItem>
)
